<template>
    <div class="inline-editor" ref="editor" id="editor"></div>
</template>

<script>
import { createEditor } from "@components/Editor/builder/editor-builder"

export default {
    props: {
        value: {
            type: String,
            default: ""
        }
    },
    name: "EditorBuilder",
    data() {
        return {
            html: this.value
        }
    },
    mounted() {
        setTimeout(() => {
            if (this.$refs.editor) {
                createEditor({
                    el: this.$refs.editor,
                    value: this.value,
                    onUpdate: value => this.$emit("update", value)
                })
            }
        })
    }
}
</script>

<style lang="scss">
$size: 60px;
.ProseMirror-menubar {
    min-height: calc($size) !important;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    justify-content: center;
    display: flex;
    z-index: 1000;
    background: #f6f6f6;
    font-family: Inter, sans-serif;
}
.ProseMirror-menuitem {
    height: $size;
    width: $size;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ProseMirror-menuseparator {
}

.ProseMirror-menu-dropdown-wrap {
    position: relative;
}

.ProseMirror-menu-dropdown-menu {
    position: absolute;
    top: calc(100%);
    background: #fff;
    padding: 4px;
    box-shadow: 0 5px 20px -5px rgba(0, 14, 66, 0.2);
    .ProseMirror-menu-dropdown-item {
        & > div {
            height: 40px;
            font-size: 14px;
            white-space: nowrap;
            display: flex;
            align-items: center;
            cursor: pointer;
            padding-left: 10px;
            padding-right: 10px;
            min-width: 80px;
            &:hover {
                cursor: pointer;
                background: #eee;
            }
        }
    }
}

.ProseMirror-menu-disabled {
    opacity: 0.4;
    pointer-events: none;
}

.ProseMirror-icon,
.ProseMirror-menu-dropdown {
    height: $size;
    width: $size;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover,
    &.ProseMirror-menu-active {
        cursor: pointer;
        background: #eee;
    }
    svg {
        width: 26px !important;
        height: 26px;
    }
    &.heading {
        background-size: 24px 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('data:image/svg+xml,<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M17 11V4H19V21H17V13H7V21H5V4H7V11H17Z"></path></svg>');
    }
}
</style>
